module.exports = __webpack_public_path__ + "img/XRP.b427c0ea.png";